var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowLineUpRight = function SvgIconArrowLineUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.71 4.545a1 1 0 0 1 .29.702v9.378a1 1 0 1 1-2 0v-6.96l-8.793 8.792a1 1 0 0 1-1.414-1.414l8.793-8.793H8.625a1 1 0 0 1 0-2H18c.275 0 .524.111.705.29zM3.75 19.25a1 1 0 1 0 0 2h16.5a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconArrowLineUpRight;